import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { TeamsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon'
import { BetOfferType } from '@mobi/api-types/kambi/constants'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { LegStatusIcon } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Common/LegStatusIcon'
import { KambiHistoryCouponDisplayContext } from '@core/Areas/KambiSports/Player/Components/Coupon/context'

export const LegsProgressStatus: React.FC<{
  outcomes: KambiHistoryCoupon['outcomes']
  betOffers: KambiHistoryCoupon['betOffers']
  events: KambiHistoryCoupon['events']
}> = ({ outcomes, betOffers, events }) => {
  const displayContext = React.useContext(KambiHistoryCouponDisplayContext)

  const shouldAlignEnd = displayContext.type === 'bet-history'

  return (
    <WrapperStyled data-align-end={shouldAlignEnd}>
      {outcomes.map(outcome => {
        if (outcome.status === 'WON' || outcome.status === 'LOST') {
          return (
            <span key={outcome.outcomeId}>
              <LegStatusIcon status={outcome.status} />
            </span>
          )
        }

        const event = events.find(e => e.eventId === outcome.eventId)
        const betOfferTypeId =
          betOffers.find(b => b.betOfferId === outcome.betOfferId)?.boTypeId ??
          BetOfferType.Handicap
        const sportName = event?.sport

        return (
          <span key={outcome.outcomeId}>
            <TeamsIcon
              outcomeId={outcome.outcomeId}
              betOfferType={betOfferTypeId}
              betOfferId={outcome.betOfferId}
              size='1.6rem'
              participantId={outcome.participantId}
              sportName={sportName}
            />
          </span>
        )
      })}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  '--leg-box-size': '2rem',

  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: spacing.smx2,
  minWidth: 0,
  minHeight: 'var(--leg-box-size)',

  '> span': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'var(--leg-box-size)',
    height: 'var(--leg-box-size)',
  },

  '&[data-align-end="true"]': {
    marginLeft: 'auto',
    justifyContent: 'flex-end',
  },
})
